import React, { useState } from 'react';
import { Input } from '../ui/input';
import api from '../../lib/api';
import { Search, Loader2 } from 'lucide-react';

/** Reusable swimmer search/picker. Calls onSelect(swimmer) when a result is chosen. */
const SwimmerSearch = ({ onSelect, placeholder = 'Search member by name, code or phone' }) => {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const search = async (value) => {
    setQ(value);
    if (!value.trim()) { setResults([]); setOpen(false); return; }
    setLoading(true);
    try {
      const res = await api.get('/swimmers', { params: { search: value, limit: 8 } });
      setResults(res.data);
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const pick = (s) => {
    onSelect(s);
    setQ('');
    setResults([]);
    setOpen(false);
  };

  return (
    <div className="relative">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        <Input
          value={q}
          onChange={(e) => search(e.target.value)}
          placeholder={placeholder}
          className="pl-9"
          data-testid="swimmer-search-input"
        />
        {loading && <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-gray-400" />}
      </div>
      {open && results.length > 0 && (
        <div className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto" data-testid="swimmer-search-results">
          {results.map((s) => (
            <button
              key={s.id}
              onClick={() => pick(s)}
              className="w-full text-left px-3 py-2 hover:bg-blue-50 flex items-center justify-between"
              data-testid={`swimmer-result-${s.id}`}
            >
              <span className="text-sm font-medium text-gray-900">{s.name}</span>
              <span className="text-xs text-gray-500">{s.swimmer_id_code}</span>
            </button>
          ))}
        </div>
      )}
      {open && !loading && results.length === 0 && q.trim() && (
        <div className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg px-3 py-2 text-sm text-gray-500">
          No members found
        </div>
      )}
    </div>
  );
};

export default SwimmerSearch;
